import { TrackedMedia } from '@ih/app/client/shared/interfaces';

export class SetTrackedMedia {
  public static readonly type = '[Notifications] SetTrackedMedia';
  constructor(public readonly trackedMedia: TrackedMedia[]) {}
}
